import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';

/**
 * Services Files
 */
import { GenerateReceiptDetailsService } from "../../../services//receipts/generateReceiptDetails/generate-receipt-details.service";



@Component({
  selector: 'app-generate-print-receipts',
  templateUrl: './generate-print-receipts.component.html',
  styleUrls: ['./generate-print-receipts.component.less']
})
export class GeneratePrintReceiptsComponent implements OnInit {

  @Input('event_id') id: any;
  @Output() outToParent = new EventEmitter<string>()

  public printReceipts: any = []

  constructor(private GenerateReceiptDetailsService: GenerateReceiptDetailsService) { }

  ngOnInit() {
    this.getEventPrintLabel(this.id.event, this.id.fee)
  }

  async getEventPrintLabel(event_id, type_id) {
    let label = await this.GenerateReceiptDetailsService.generateReceiptDetails(event_id, type_id)
    this.printReceipts = label.data 
    console.log(this.printReceipts)
    await this.notificationToParent()
  }

  async notificationToParent() {
    setTimeout(() => {
    this.outToParent.emit("emit")
  }, 1000)
  }

}
